/* Presentation-only adapters. No request, mutation, storage, event or timer.
 * The operational formatters in aval-booking-core.js remain unmodified. */
(function () {
  'use strict';
  const text = key => window.AVAL_EDITOR_COPY('aval-common-values', key);
  const escapeHtml = value => String(value).replace(/[&<>"']/g, ch => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[ch]));
  window.AVAL_EDITOR_ART = function (value, emptyFallback) {
    if (!value) return emptyFallback ? '' : text('aval_value_kind_unspecified');
    const raw = String(value);
    const code = raw.toLowerCase();
    if (['palette','karton','kiste','paket','bigbag','sonstiges'].includes(code)) return text('aval_value_kind_' + code);
    // Unknown values are operational/customer data, not a hidden editorial fallback.
    return raw.charAt(0).toUpperCase() + raw.slice(1).toLowerCase();
  };
  window.AVAL_EDITOR_TIME = function (value, fixTime, mode) {
    const raw = String(value || '').trim();
    const html = mode !== 'text';
    const output = v => html ? escapeHtml(v) : String(v);
    if (!raw) return '';
    if (raw === 'FIX') return output(text('aval_value_fixed_time')) + (mode !== 'text' && fixTime ? ' (' + escapeHtml(fixTime) + ' ' + output(text('aval_value_time_unit')) + ')' : '');
    // A worker-supplied display value containing its own unit remains external data.
    if (/Uhr/i.test(raw)) return output(raw);
    const match = raw.match(mode === 'core' ? /^(\d{2}:\d{2})\s*-\s*(\d{2}:\d{2})$/ : /^(\d{2}:\d{2})-(\d{2}:\d{2})$/);
    if (match) return output(match[1] + ' ' + text('aval_value_time_unit') + ' - ' + match[2] + ' ' + text('aval_value_time_unit'));
    return output(raw);
  };
  window.AVAL_EDITOR_DATE_LABEL = function (date, time, formatDate) {
    if (!date) return '–';
    const label = window.AVAL_EDITOR_TIME(time || '', '', 'text');
    return formatDate(date) + (label ? ' (' + label + ')' : '');
  };
  window.AVAL_EDITOR_PAYMENT = function (code, operationalLabel) {
    const keys = {rechnung:'aval_value_payment_invoice',paypal:'aval_value_payment_paypal',klarna:'aval_value_payment_klarna',kreditkarte:'aval_value_payment_card'};
    return Object.prototype.hasOwnProperty.call(keys, code) ? text(keys[code]) : String(operationalLabel || '');
  };
  // Display only: the supplied worker's stable codes choose editor text.
  // Raw messages and serialized booking data are never modified. Unknown responses stay external data.
  window.AVAL_EDITOR_SERVICE_MESSAGE = function (data, fallback) {
    if (!data || typeof data !== 'object' || typeof data.message !== 'string' || !data.message) return fallback;
    const code = typeof data.error === 'string' ? data.error : data.reason;
    const codes = {"invalid_json": "aval_svc_invalid_json", "admin_pin_not_configured": "aval_svc_admin_pin_not_configured", "unauthorized": "aval_svc_unauthorized", "kv_not_bound": "aval_svc_kv_not_bound", "route_points_missing": "aval_svc_route_points_missing", "invalid_route_points": "aval_svc_invalid_route_points", "window_missing": "aval_svc_window_missing", "window_invalid": "aval_svc_window_invalid", "no_vehicle_configured": "aval_svc_no_vehicle_configured", "no_vehicle": "aval_svc_no_vehicle", "vehicle_location_missing": "aval_svc_vehicle_location_missing", "busy_conflict": "aval_svc_busy_conflict", "not_available": "aval_svc_not_available", "pickup_window_too_early": "aval_svc_pickup_window_too_early", "delivery_window_too_early": "aval_svc_delivery_window_too_early", "date_missing": "aval_svc_date_missing", "hold_missing": "aval_svc_hold_missing", "hold_not_found_or_expired": "aval_svc_hold_not_found_or_expired", "hold_expired": "aval_svc_hold_expired", "hold_max_lifetime_reached": "aval_svc_hold_max_lifetime_reached", "booking_missing": "aval_svc_booking_missing", "booking_not_found": "aval_svc_booking_not_found", "location_missing": "aval_svc_location_missing", "missing_location": "aval_svc_missing_location", "google_key_missing": "aval_svc_google_key_missing", "geocode_failed": "aval_svc_geocode_failed"};
    if (!Object.prototype.hasOwnProperty.call(codes, code)) return fallback;
    let key = codes[code];
    // publicUnavailable has a second defined fallback for an absent reason/message.
    if (code === 'not_available' && data.message === 'Dieses Zeitfenster ist nach aktueller Fahrzeugverfügbarkeit leider nicht realistisch.') key = 'aval_svc_not_available_fallback';
    let suffix = '';
    if (code === 'geocode_failed') {
      const separator = data.message.indexOf(': ');
      if (separator < 0) return fallback;
      suffix = data.message.slice(separator + 2);
    }
    const display = window.AVAL_EDITOR_COPY('aval-service-messages', key);
    return display && suffix ? display + ' ' + suffix : display;
  };
  // Errors remain errors even when their visible text is deliberately empty.
  window.AVAL_EDITOR_SERVICE_ERROR = function (data, originalMessage) {
    const error = new Error(originalMessage);
    Object.defineProperty(error, '__avalDisplayMessage', {
      value: window.AVAL_EDITOR_SERVICE_MESSAGE(data, originalMessage), enumerable: false
    });
    return error;
  };
  window.AVAL_EDITOR_ERROR_TEXT = function (error) {
    return error && Object.prototype.hasOwnProperty.call(error, '__avalDisplayMessage')
      ? String(error.__avalDisplayMessage) : String(error && error.message || error);
  };
}());
